import { actions } from '..';
import * as api from '../../api';
import * as apiQueue from '../../api/queue-control';
import { getCommandById } from '../reducers/command';
import { selectConfigProp, selectApplicationSetting } from '../reducers/config';
import { all } from 'async-saga';
import { takeEvery } from '../tools/async-saga-types';

const acceptCommand = takeEvery(actions.acceptCommand, async function (ctx, { id, callId }) {
  const state = ctx.getState();
  const command = getCommandById(state, id)
  const agent = selectConfigProp(state, 'agentDisplayName')
  const view = selectApplicationSetting(ctx.getState(), 'AgentViewOnAnswer')

  if (command && agent) {
    await api.commandAccept(command, agent, command.Header.TransactionId)

    if ((!view || view && view.value === 'true')) {
      ctx.dispatch(actions.openAgentView(callId))
    }
  }
})

const declineCommand = takeEvery(actions.declineCommand, async function (ctx, id) {
  const state = ctx.getState();
  const command = getCommandById(state, id)
  const agent = selectConfigProp(state, 'agentDisplayName')

  if (command && agent) {
    //tell server
    await api.commandDecline(command, agent, command.Header.TransactionId)
  }
})

const disconnectCommand = takeEvery(actions.disconnectCommand, async function (ctx, { mediaItemId, mediaId }) {
  const state = ctx.getState();
  const command = getCommandById(state, mediaItemId)
  const agent = selectConfigProp(state, 'agentDisplayName')

  if (command && agent) {
    api.commandDisconnect(command, agent, command.Header.TransactionId)
  } else if (mediaId) {
    apiQueue.closeMediaItem(mediaId)
  }
})

export default all(
  acceptCommand,
  declineCommand,
  disconnectCommand,
)
